import { convertDateFromDateArray } from '@/utils/time';
import { BackendType, FrontendType, ObjectType } from '@/models/general';

export type Customer<T extends ObjectType = FrontendType> = {
    city: string;
    country: string;
    email: string;
    firstname: string;
    groups: string[];
    guest: boolean;
    id: string;
    lastname: string;
    marketingAcceptance: boolean;
    marketingAcceptanceDate: T extends BackendType ? number[] : Date;
    notes?: string;
    phone: string;
    salutation: string;
    street: string;
    title: string;
    zipcode: string;
    language: 'de' | 'en' | null;
};

export type SlimCustomer = Omit<
    Customer,
    'id' | 'marketingAcceptance' | 'marketingAcceptanceDate' | 'groups'
>;

export type BackendCustomer = {
    city: string;
    country: string;
    email: string;
    firstname: string;
    groups: [];
    guest: boolean;
    id: string;
    lastname: string;
    marketingAcceptance: boolean;
    marketingAcceptanceDate: number[];
    notes?: string;
    phone: string;
    salutation: string;
    street: string;
    title: string;
    zipcode: string;
    language: 'de' | 'en' | null;
};

export const transformCustomerFromResponse = (
    customer: Customer<BackendType>
): Customer => ({
    ...customer,
    marketingAcceptanceDate: convertDateFromDateArray(
        customer.marketingAcceptanceDate
    ),
});

export type GetCustomerSearchParams = {
    size?: number;
    page?: number;
    sort?: string;
    search?: string;
};
